/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Promoted_MainInputs */

const cs_property_ai_promoted_main = /** @type {(inputs: Property_Ai_Promoted_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidáno jako hlavní fotka`)
};

const en_property_ai_promoted_main = /** @type {(inputs: Property_Ai_Promoted_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added as main photo`)
};

/**
* | output |
* | --- |
* | "Added as main photo" |
*
* @param {Property_Ai_Promoted_MainInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_promoted_main = /** @type {((inputs?: Property_Ai_Promoted_MainInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Promoted_MainInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_promoted_main(inputs)
	return cs_property_ai_promoted_main(inputs)
});